import { Alert } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function AmendsMissingTaskHint() {
    const { task, target, editMode, amendsContext, getTaskAmendsKey } = useBoundContext()
    if (!amendsContext || !getTaskAmendsKey) return null

    const contextTarget = target ?? task
    const amendsKey = getTaskAmendsKey(contextTarget)
    if (!amendsKey) return null

    const state = amendsContext.getAmendsState(amendsKey)
    if (!editMode || !state.canOpen || state.hasSavedAmends || state.isOpen) return null

    return (
        <Alert severity="info" variant="outlined" sx={{ py: 0.5, mb: 1 }} data-cy="task-amends-hint">
            This task does not have author notes attached. Adding notes is recommended so they are included when this
            group is applied across schedules.
        </Alert>
    )
}
